import React from 'react';

const PreciousMetals = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Precious Metals Trade
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures offers strategic trading and investment services in precious metals including gold, silver, platinum, and other valuable commodities, providing clients with secure and profitable opportunities.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Our Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Gold Trading</h3>
                <p className="text-gray-700">
                  Strategic gold trading and investment services with expert market analysis, timing, and execution for optimal returns in the gold market.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Silver & Platinum</h3>
                <p className="text-gray-700">
                  Comprehensive trading services for silver, platinum, and other precious metals with market insights and strategic positioning.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Precious Metals Portfolio</h3>
                <p className="text-gray-700">
                  Diversified precious metals portfolio management combining physical holdings and financial instruments for wealth preservation and growth.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Market Analysis & Advisory</h3>
                <p className="text-gray-700">
                  Expert market analysis, price forecasting, and strategic advisory services helping clients make informed decisions in precious metals trading.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Invest in Precious Metals</h3>
              <p className="mb-6">
                Discover secure and profitable precious metals trading opportunities with Vajreya Ventures.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Start Trading
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreciousMetals;